import { useState, useEffect } from 'react';
import MantineImage from '../../components/mantine/image';
import { Button, Container, Paper, Group, Center, Text, Box } from '@mantine/core';
import CustomPinInput from '../../components/mantine/pinInput';
import Logo from '../../assets/images/jb-logo.svg';
import RightImage from '../../assets/images/login-right-bg.svg';
import RightArrow from '../../assets/images/login-arw.svg';


interface iForm {
    handleChange?: any,
    Verify2Fa: any,
    formData: any
}

const Form = ({ handleChange, formData, Verify2Fa }: iForm) => {
    const [timer, setTimer] = useState(5);
    const [canResend, setCanResend] = useState(false);
   
    // useEffect(() => {
    //     if (timer > 0) {
    //         const interval = setInterval(() => {
    //             setTimer(prev => prev - 1);
    //         }, 1000);
    //         return () => clearInterval(interval);
    //     } else {
    //         setCanResend(true);
    //     }
    // }, [timer]);

    // const handleResendCode = () => {
    //     formData.setFieldValue('Code', '');
    //     //dispatch(resendVerificationCode());
      
    //     setCanResend(false);
    //     setTimer(5);
    //   };
      
    return (
        <Container fluid className='overflow-hidden flex h-screen p-0 item-center justify-between bg-[#041E42] w-full'>
            <Group className='relative h-full flex-col max-w-[435px] w-full justify-center'>
                <Paper className='bg-transparent w-full'>
                    <Center mb="2rem">
                        <MantineImage src={Logo} className="max-w-[130px] w-full" />
                    </Center>
                    <form onSubmit={Verify2Fa}>
                        <Group mb='lg' className='bg-[#2F7FE2] flex-col rounded-tr-[46px] rounded-br-[46px] p-8 flex-1 w-full item-start'>
                            <div className="flex flex-col items-start w-full">
                                <label className="text-white mb-2 text-[13px] leading-[16px] font-bold self-start">
                                    Verify Code
                                </label>
                                <CustomPinInput 
                                 {...formData?.getInputProps('Code')}                                
                                    length={6}
                                    value={formData?.values?.Code}
                                    onChange={(value: string) => formData.setFieldValue('Code', value)}
                                    error={formData.errors.Code}
                                />
                                 
                            </div>
                            {/* <Text color="white" className="text-sm">
                                {canResend ? (                                    
                                    <Text
                                        onClick={handleResendCode}
                                        size="xs"                                      
                                        className="text-white text-sm cursor-pointer bg-transparent border-none p-0 underline"
                                    >
                                        Resend Code
                                    </Text>
                                ) : (
                                    `Resend code in ${timer}s`
                                )}
                            </Text> */}
                        </Group>

                        <Group>
                            <Button
                                fullWidth
                                size="md"
                                style={{ backgroundColor: '#FF5C39', color: 'white', borderRadius: '0px 16px 16px 0px', height: 54, fontSize: '1.125rem' }}                                
                                onClick={Verify2Fa}
                                type='submit'
                            >
                                Verify
                                <MantineImage src={RightArrow} style={{ marginLeft: '20px', width: '40px' }} />
                            </Button>
                        </Group>
                    </form>
                </Paper>
                <Text className='text-xs text-white absolute bottom-2 left-0 text-center w-full'>© 2026 JB360</Text>
            </Group>
            <Group className='sm-hidden mr-[20px] h-full flex items-end'>
                <Box maw={227} mx="auto" className="h-full">
                    <div className="curve-custom h-full bg-no-repeat bg-cover" style={{ backgroundImage: `url(${RightImage})` }} />
                </Box>
            </Group>
        </Container>
    );
};

export default Form;


